import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { NewServiceOrder } from '../../serviceOrders/components/NewServiceOrder';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejNewServiceOrderPage = () => {
  const { apps, customerType } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej && customerType === 'ipr' ? (
        <AppWrapper
          appType={APP_TYPE.VYDEJ}
          menu={<VydejMenu />}
          resource='ServiceOrders'
          action='create'
        >
          <NewServiceOrder />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejNewServiceOrderPage;
